/* eslint-disable camelcase */
type Locale = 'en' | 'es';
type Variables = {
  type: string;
};
type Phrase = (l: Locale, v: Variables) => string;

export const i18n_sign_in_or_create_to_access: Phrase = (locale, variables) => {
  const phrases: { [key: string]: undefined | string } = {
    en: `Sign in or create an account to access this ${variables.type}`,
    es: `Inicia sesión o crea una cuenta para tener acceso a este ${variables.type}`,
  };
  return phrases[locale] || phrases.en || `Sign in or create an account to access`;
};
